import {z} from 'zod';
import {z as z4} from 'zod/v4';

export const OBJECT_ID_FORMAT = /^[a-f0-9]{24}$/i;

/**
 * Schema represents an ObjectId-formatted string. If a non-string value is
 * provided, it will be coerced to a string.
 *
 * @example
 * const Foo = z.object({id: objectIdString});
 * // Input type:  {id: string}
 * // Output type: {id: string}
 *
 * const foo = Foo.parse({id: null}); // ❌
 * const foo = Foo.parse({id: undefined}); // ❌
 * const foo = Foo.parse({id: 'abc123'}); // ❌
 * const foo = Foo.parse({id: '68cdb4b5a699862fcd8c1a01'}); // {id: string} ✅
 * const foo = Foo.parse({id: new ObjectId()}); // {id: string} ✅
 */
export const objectIdString = z.coerce
  .string()
  .regex(OBJECT_ID_FORMAT, 'Invalid ObjectId format');

/**
 * Schema represents an ObjectId-formatted string. If a non-string value is
 * provided, it will be coerced to a string.
 *
 * @example
 * const Foo = z.object({id: objectIdString});
 * // Input type:  {id: string}
 * // Output type: {id: string}
 *
 * const foo = Foo.parse({id: null}); // ❌
 * const foo = Foo.parse({id: undefined}); // ❌
 * const foo = Foo.parse({id: 'abc123'}); // ❌
 * const foo = Foo.parse({id: '68cdb4b5a699862fcd8c1a01'}); // {id: string} ✅
 * const foo = Foo.parse({id: new ObjectId()}); // {id: string} ✅
 */
export const objectIdStringZ4 = z4.coerce
  .string()
  .regex(OBJECT_ID_FORMAT, 'Invalid ObjectId format');
